(function () {
    'use strict';
    angular.module('app').controller('ChangeTrackingStatusModalController', ChangeTrackingStatusModalController);
    ChangeTrackingStatusModalController.$inject = [
        '$uibModalInstance',
        '$rootScope',
        'shipmentIds',
        'toastr',
        'Shipments'
    ];

    function ChangeTrackingStatusModalController(
        $uibModalInstance,
        $rootScope,
        shipmentIds,
        toastr,
        Shipments
    ){
        const vm =this;
        vm.userDetails = angular.copy($rootScope.GlobalProfile);
        vm.shipmentIds = angular.copy(shipmentIds);

        vm.categoryTypeList = [
            {label: 'DOCUMENTATION PREPARED',value:'DOCUMENTATIONPREPARED'},
            {label: 'BOOKING ARRANGED',value:'BOOKINGARRANGED'},
            {label: 'COLLECTED',value:'COLLECTED'},
            {label: 'IN TRANSIT',value:'INTRANSIT'},
            {label: 'ARRIVED AT DESTINATION',value:'ARRIVEDATDESTINATION'},
            {label: 'OUT FOR DELIVERY',value:'OUTFORDELIVERY'},
            {label: 'DELIVERED',value:'DELIVERED'},
            {label: 'IN STORE',value:'INSTORE'},
            {label: 'MISSING',value:'MISSING'},
            {label: 'ATTEMPTED DELIVERY',value:'ATTEMPTED_DELIVERY'},
            {label: 'AWAITING COLLECTION',value:'AWAITING_COLLECTION'},
            {label: 'CANCELLED',value:'CANCELLED'},
            {label: 'CUSTOMS HELD',value:'CUSTOMS_HELD'},
            {label: 'DAMAGED',value:'DAMAGED'},
            {label: 'RETURN TO SENDER',value:'RETURN_TO_SENDER'},
            {label: 'ON FORWARDED',value:'ON_FORWARDED'}
        ]

        vm.closeModal = function(){
            $uibModalInstance.close()
        }

        vm.onSelectType = function(selected){
            // console.log(selected)
        }

        vm.submit = function(form){
            
            if(form.$invalid){
                angular.forEach(form.$error, function(fields){
                    angular.forEach(fields, function(field){
                        field.$setTouched();
                    });
                });
                return;
            }

            const payload =[]
            vm.shipmentIds.forEach(shipmentId => {
                payload.push({
                    shipmentId: shipmentId,
                    status: vm.category.value,
                    note: vm.notes || ''
                });
            });

           changeStatus(payload)
        }


        init()
        function init(){
            // console.log(shipmentIds)
        }

        function changeStatus(payload){
            Shipments.changeStatusShipments(payload, () => {
                toastr.success('Shipment successfully archived');
                $uibModalInstance.close(true)
            }, () => {
                toastr.error('Unable to archive shipment.', 'Please try again later');
                $uibModalInstance.dismiss()
            });
        }
    }
})()


// WEBPACK FOOTER //
// ./js/controllers/shipment/modal/ChangeTrackingStatusModalController.js